import Model, { attr, belongsTo } from "@ember-data/model";
import { tKey } from "ember-intl";

export default class FileStorageVolumeModel extends Model {
  @attr accessList;
  @attr cost;
  @attr dataCenter;
  @attr("yesno") hasAutoPromotion;
  @attr fqdn;
  @attr("yesno") isLocked;
  @attr plan;
  @attr name;
  @attr status;
  @attr("number") used;
  @attr maintenancewindow;

  get nfsUrl() {
    let fqdn = this.fqdn;
    return fqdn ? `nfs://${fqdn}/dpool/nfs` : null;
  }

  get statusIndicator() {
    if (this.status === "ready") {
      return { state: "online", labelKey: tKey("label.online") };
    }

    if (this.status === "creating") {
      return { state: "busy", showSpinner: true, labelKey: tKey("file-storage-volumes.status.creating") };
    }

    if (this.status === "updating") {
      return { state: "busy", labelKey: tKey("file-storage-volumes.status.updating") };
    }

    return { state: "busy", showSpinner: true };
  }

  get usedPercentage() {
    let { plan, used } = this;

    return Math.round((used / plan.quota) * 100);
  }

  @belongsTo("project", { async: false, inverse: "fileStorageVolumes" }) project;
}
